import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Overview from './components/Overview';
import BoundaryScale from './components/BoundaryScale';
import ViolationCases from './components/ViolationCases';
import RemoveReasons from './components/RemoveReasons';
import Checklist from './components/Checklist';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <BoundaryScale />
        <ViolationCases />
        <RemoveReasons />
        <Checklist />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}